<app-platform-start></app-platform-start>
<div appLazyLoad (inViewport)="loadComponent(componentsEnum.SLIDER)">
  <app-infinite-slider *ngIf="isComponentLoaded(componentsEnum.SLIDER)"></app-infinite-slider>
</div>
<div appLazyLoad (inViewport)="loadComponent(componentsEnum.DEMO)">
  <app-demo *ngIf="isComponentLoaded(componentsEnum.DEMO)"></app-demo>
</div>
<div appLazyLoad (inViewport)="loadComponent(componentsEnum.FAQS)">
  <app-faqs *ngIf="isComponentLoaded(componentsEnum.FAQS)"></app-faqs>
</div>
<div appLazyLoad (inViewport)="loadComponent(componentsEnum.RECORD)">
  <app-record *ngIf="isComponentLoaded(componentsEnum.RECORD)"></app-record>
</div>
<div appLazyLoad (inViewport)="loadComponent(componentsEnum.METRICS)">
  <app-pwa-metrics *ngIf="isComponentLoaded(componentsEnum.METRICS)"></app-pwa-metrics>
</div>
